// frontend/src/components/Layout/CustomerLayout.tsx
import React from 'react';
import BaseLayout from './BaseLayout';
import { customerLayoutConfig } from './configs/layoutConfigs';

interface CustomerLayoutProps {
  children: React.ReactNode;
}

const CustomerLayout: React.FC<CustomerLayoutProps> = ({ children }) => {
  return (
    <BaseLayout config={customerLayoutConfig}>
      {children}
    </BaseLayout>
  );
};

export default CustomerLayout;